<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="scaling-svg">
      <path
        d="M12.727,8.273H8.273v4.455a1.273,1.273,0,0,1-2.545,0V8.273H1.273a1.273,1.273,0,1,1,0-2.545H5.727V1.273a1.273,1.273,0,0,1,2.545,0V5.727h4.455a1.273,1.273,0,1,1,0,2.545Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PlusIcon extends Vue {}
</script>

<style>
</style>
